var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.claim.customer)?_c('Typography',{attrs:{"variant":"body-2"}},[_vm._v("Customer: "+_vm._s(_vm.claim.customer))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }